module.exports = __webpack_public_path__ + "static/media/intro15.47d6f416.svg";